import { Component, Inject, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CaseView } from '../../models/caseview.model';
import { forkJoin, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';


export class customData {
  selectedData: CaseView[];
  isFromCustomAction: boolean;
}

@Component({
  selector: 'app-revoke-case',
  templateUrl: './revoke-case.component.html',
  styleUrls: ['./revoke-case.component.scss']
})

export class RevokeCaseComponent {
  constructor(private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: customData,
    private dialogRef: MatDialogRef<RevokeCaseComponent>,
    public translate: TranslateService) { }

  /* revokeCase() {
    const recId = 2431;
    const appTypeId = 1;
    const revokeUrl = '/workflow/revoke';
    const data = {
       recId: recId,
      appTypeId: appTypeId,
    };
    this.http.post(revokeUrl, data)
      .subscribe(
        (response) => {
          console.log('Case Revoked successfully:', response);
        },
        (error) => {
          console.error('Error revoking case:', error)
        }
      );
  } */

  revokeCase(): void {
    const caseDataArray = this.data?.selectedData;
    const apiList = [];
    caseDataArray.forEach((data) => {
      const dataForPost = {
        recId: Number(data.docId),
        appTypeId: data.appTypeId == '3' ? 3 : 1,
      };
      const api = this.http
        .post('/workflow/revoke', dataForPost)
        .pipe(
          map((r) => !!r),
          catchError((e) => of(false))
        );
      apiList.push(api);
    });
    forkJoin(apiList).subscribe((resArr: boolean[]) => {
      const anySuccess = resArr.some((r) => !!r);
      this.dialogRef.close(anySuccess);
    });
  }
}